import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { BrowserRouter as Router, Switch, Route, Link, useHistory } from "react-router-dom";
import { PermissionsProvider, usePermissions } from "./PermissionContext.js";
import Login from "../Login/Login";
import { Menu, Layout, message } from "antd";
import {
  PieChartOutlined,
  MailOutlined,
  ContainerOutlined,
  LogoutOutlined,
  UserOutlined,
  CarryOutOutlined,
  DollarOutlined,
  SettingOutlined,
  LineChartOutlined,
  MoneyCollectOutlined,
  FilePdfOutlined,
  RiseOutlined,
  DashboardOutlined,
  CalendarOutlined,
  TagOutlined,
  TagsOutlined,
  CloudSyncOutlined,
  TeamOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import { PERMISSIONS } from "../../constants/roles";
import "./App.css";
import "antd/dist/antd.css";
import { LOGOUT } from "./../../features/counter/authSlice";
import { getFeatureFlag } from "../../config/featureFlag"

import Dashboard from "../Dashboard/Dashboard";
import User from "../User/User";
import UserDetails from "../User/UserDetails";
import AllOrder from "../Order/AllOrder";
import NextDayRemittanceOrder from "../Order/NextDayRemittanceOrder";
import ClaimPayout from "../Order/ClaimPayout.js";
import CodOrder from "../Order/CodOrder";
import ReturnedOrder from "../Order/ReturnedOrder";
import DiscountCode from "../DiscountCode/DiscountCode";
import BannerInactive from "../Banner/Inactive";
import BannerActive from "../Banner/Active";
import BulkDownloadConsignNote from "../ConsignNote/BulkDownloadConsignNote";
import Analysis from "../Analysis/Analysis";
import CodAnalysis from "../Analysis/CodAnalysis";
import CourierAnalysis from "../Analysis/CourierAnalysis";
import Remittance from "../Remittance/Remittance";
import Payout from "../Remittance/Payout";
import Beneficiary from "../Payout/Beneficiary";
import CheckRemittance from "../Remittance/CheckRemittance";
import AddQuestionaire from "../Questionaire/AddQuestionaire";
import Questionaire from "../Questionaire/Questionaire";
import QuestionaireDetails from "../Questionaire/QuestionaireDetails";
import Email from "../Email/Email";
import Export from "../Export/Export";
import Transaction from "../Transactions/Transaction";
import Insurance from "../Insurance/Insurance";
import SupportTicket from "../SupportTicket/SupportTicket";
import CargoActivation from "../CargoActivation/CargoActivation";
import SupportTicketDetail from "../SupportTicket/SupportTicketDetail";
import FlyersRequest from "../FlyersRequest/FlyersRequest";
import Settings from "../Settings/Settings";
import ReceiverOrderStats from "../Receiver/ReceiverOrderStats";
import Package from "../Package/Package";
import TopupPackagePricing from "../Package/TopupPackagePricing";
import TopupPackageCost from "../Package/TopupPackageCost";
import FeePackagePricing from "../Package/FeePackagePricing";
import CourierPackagePricing from "../Package/CourierPackagePricing";
import CancelRequest from "../Order/CancelRequest";
import UnrecognizedStatusOrder from "../Order/UnrecognizedStatusOrder";
import AccountManager from "../AccountManager/AccountManager";
import AccountManagerDetails from "../AccountManager/AccountManagerDetails";
import ReferralAccount from "../ReferralAccount/ReferralAccount";
import ReferreeAccountList from "../ReferralAccount/ReferreeAccountList";
import POD from "../POD/POD";
import WeightDispute from "../WeightDispute/WeightDispute";
import WeightDisputeByMerchant from "../WeightDispute/WeightDisputeByMerchant";
import NotificationAnalysis from "../Analysis/NotificationAnalysis";
import SubAccount from "../SubAccount/SubAccount";
import SubAccountDetails from "../SubAccount/SubAccountDetails";
import PayoutStatus from "../Payout/PayoutStatus";
import PayoutWithdrawal from "../Payout/PayoutWithdrawal";
import PickupRequest from "../Order/PickupRequest.js";
import CodCalendar from "../CodReconcilation/Calender.js";
import Otp from "../Otp/Otp.js";
import AdminAuditLogs from "../AdminAuditLogs/AdminAuditLogs.js";
import AdminJob from "../AdminJob/AdminJob.js";
import OrderEvent from "../Order/OrderEvent";
import Notification from "../Notification/Notification";
import Pnl from "../PnL/Pnl.js";
import News from "../News/News";
import Banner from "../Banner/Banner";
import UserAuditLogs from "../UserAuditLogs/UserAuditLogs.js";
import BonusCampaign from "../BonusCampaign/BonusCampaign.js";

import moment from "moment";
import Voucher from "../Voucher/Voucher.js";
import VoucherRedemption from "../Voucher/VoucherRedemption.js";
import Announcement from "../Announcement/Announcement";
import BeneficiaryRequest  from "../BeneficiaryRequest/BeneficiaryRequest.js";
import PointHistory from "../PointHistory/PointHistory";
import Mission from "../Mission/Mission";
import CurrencyConversion from "../CurrencyConversion/CurrencyConversion";
import RewardCatalog from "../RewardCatalog/RewardCatalog";
import RedemptionSettings from "../RedemptionSettings/RedemptionSettings";
import Redemption from "../Redemption/Redemption";
import RedemptionReport from "../RedemptionReport/RedemptionReport";

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const App = ({ isAuthenticated, token, email }) => {
  return (
    <PermissionsProvider token={token}>
      <InnerApp isAuthenticated={isAuthenticated} email={email} />
    </PermissionsProvider>
  );
};

const InnerApp = ({ isAuthenticated, email }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { permissions } = usePermissions(); // Corrected here to match the provider output
  const [collapse, setCollapse] = useState(false);
  if (!permissions) {
    return <div>Loading permissions...</div>; // Handle loading state
  }

  const handleLogout = () => {
    console.log("Logging out..."); // Log for confirmation
    dispatch(LOGOUT()); // Dispatch the logout action
    message.success("Successfully logged out"); // Show success message
    history.push("/login"); // Redirect to login page
    window.location.reload(); // Reload the window to clear state (optional)
  };

  return (
    <div>
      {isAuthenticated ? (
        <Router>
          <Layout>
            <Sider
              width={220}
              breakpoint="lg"
              collapsedWidth="0"
              collapsible={true}
              onBreakpoint={(broken) => {
                // console.log(broken);
              }}
              onCollapse={(collapsed, type) => {
                // console.log(collapsed, type);
              }}
            >
              {/* <div className="ant-layout-logo" >LOGO</div> */}
              <Menu
                defaultSelectedKeys={["3"]}
                // defaultOpenKeys={['sub1']}
                mode="inline"
                theme="dark"
                collapsed={collapse}
              >
                {permissions?.includes(PERMISSIONS.VIEW_ANALYSIS_PAGE) && (
                  <SubMenu
                    key="analyticsMenu"
                    title="Analytics"
                    icon={<LineChartOutlined />}
                  >
                    {permissions?.includes(
                      PERMISSIONS.VIEW_DASHBOARD_ANALYTICS
                    ) && (
                      <Menu.Item key="dashboard">
                        <Link to={`/`} activeclassname="active">
                          <DashboardOutlined />
                          <span>Dashboard</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.VIEW_GENERAL_ANALYTICS
                    ) && (
                      <Menu.Item key="general-analytics">
                        <Link to={`/analysis`} activeclassname="active">
                          <PieChartOutlined />
                          <span>General</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.VIEW_ORDER_ANALYTICS
                    ) && (
                      <Menu.Item key="order-analytics">
                        <Link to={`/courier-order-analysis`} activeclassname="active">
                          <PieChartOutlined />
                          <span>Courier Order</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_COD_ANALLYTICS) && (
                      <Menu.Item key="cod-analytics">
                        <Link to={`/cod-analysis`} activeclassname="active">
                          <MoneyCollectOutlined />
                          <span>COD</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.VIEW_NOTIFICATION_ANALYTICS
                    ) && (
                      <Menu.Item key="notification-analytics">
                        <Link to={`/notification-analysis`} activeclassname="active">
                          <MoneyCollectOutlined />
                          <span>Notification</span>
                        </Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}

                {permissions?.includes(PERMISSIONS.VIEW_USER_PAGE) && (
                  <Menu.Item key="1">
                    <Link to={`/user`} activeclassname="active">
                      <UserOutlined />
                      <span>User</span>
                    </Link>
                  </Menu.Item>
                )}
                {permissions?.includes(PERMISSIONS.SUBACCOUNT_PAGE) && (
                  <Menu.Item key="subaccount">
                    <Link to={`/sub-account`} activeclassname="active">
                      <UserOutlined />
                      <span>Sub Account</span>
                    </Link>
                  </Menu.Item>
                )}

                {permissions?.includes(PERMISSIONS.VIEW_ORDER_PAGE) && (
                  <SubMenu key="orderMenu" icon={<MailOutlined />} title="Order">
                    <Menu.Item key="allOrder">
                      <Link to={`/all-order`} activeclassname="active">
                        <PieChartOutlined />
                        <span>All Order</span>
                      </Link>
                    </Menu.Item>
                    {permissions?.includes(PERMISSIONS.NDR_ODRER_PAGE) && (
                      <Menu.Item key="nextDayRemittanceOrder">
                        <Link to={`/order/next-day-remittance-order`} activeclassname="active">
                          <PieChartOutlined />
                          <span>Next-day Remittance</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.CLAIM_PAYOUT_PAGE)
                      && getFeatureFlag("newClaimPayoutFlow")
                      && (
                        <Menu.Item key="claimPayoutOrder">
                          <Link to={`/order/claim-payout`} activeclassname="active">
                            <PieChartOutlined />
                            <span>Claim Payout</span>
                          </Link>
                        </Menu.Item>
                      )}
                    {permissions?.includes(PERMISSIONS.COD_ORDER_PAGE) && (
                      <Menu.Item key="codOrder">
                        <Link to={`/order/cod-order`} activeclassname="active">
                          <PieChartOutlined />
                          <span>COD</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.RETURNED_ORDER_PAGE) && (
                      <Menu.Item key="returnedOrder">
                        <Link to={`/order/returned-order`} activeclassname="active">
                          <PieChartOutlined />
                          <span>Returned</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.CANCEL_REQUEST_ORDER_PAGE
                    ) && (
                      <Menu.Item key="cancelOrderRequest">
                        <Link
                          to={`/order/cancel-request`}
                          activeclassname="active"
                        >
                          <PieChartOutlined />
                          <span>Cancel Request</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_UNKNOWN_STATUS) && (
                      <Menu.Item key="unrecognizedStatusOrder">
                        <Link to={`/order/unrecognized-status`} activeclassname="active">
                          <PieChartOutlined />
                          <span>Unknown Status</span>
                        </Link>
                      </Menu.Item>
                    )}

                    {permissions?.includes(PERMISSIONS.RIDER_INFO) && (
                      <Menu.Item key="pickupRequest">
                        <Link to={`/order/pickup-request`} activeclassname="active">
                          <PieChartOutlined />
                          <span>Pickup Request</span>
                        </Link>
                      </Menu.Item>
                    )}

                    <Menu.Item key="flashPOD">
                      <Link to={`/order/pod`} activeclassname="active">
                        <PieChartOutlined />
                        <span>POD</span>
                      </Link>
                    </Menu.Item>

                    <Menu.Item key="orderEvent">
                      <Link to={`/order/order-event`} activeclassname="active">
                        <PieChartOutlined />
                        <span>Order Event</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                )}

                {permissions?.includes(PERMISSIONS.VIEW_TRANSACTION_PAGE) && (
                  <Menu.Item key="4">
                    <Link to={`/transaction`} activeclassname="active">
                      <DollarOutlined />
                      <span>Transaction</span>
                    </Link>
                  </Menu.Item>
                )}

                {permissions?.includes(PERMISSIONS.PACKAGE_PAGE) && (
                  <SubMenu key="packageMenu" icon={<DollarOutlined />} title="Package">
                    <Menu.Item key="allPackage">
                      <Link to={`/package`} activeclassname="active">
                        <PieChartOutlined />
                        <span>All Package</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="topupPackagePricing">
                      <Link to={`/topup-package/pricing`} activeclassname="active">
                        <DollarOutlined />
                        <span>Pricing</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="topupPackageCost">
                      <Link to={`/topup-package/cost`} activeclassname="active">
                        <DollarOutlined />
                        <span>Cost</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="feePackagePricing">
                      <Link to={`/fee-package/pricing`} activeclassname="active">
                        <DollarOutlined />
                        <span>Fee Pricing</span>
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="courierPackagePricing">
                      <Link to={`/courier-package/pricing`} activeclassname="active">
                        <DollarOutlined />
                        <span>Courier Pricing</span>
                      </Link>
                    </Menu.Item>
                  </SubMenu>
                )}

                {permissions?.includes(PERMISSIONS.MARKETING_PAGE) && (
                  <SubMenu key="bannerMenu" title="Marketing" icon={<TeamOutlined />}>
                    {permissions?.includes(PERMISSIONS.DISCOUNT_CODE_PAGE) && (
                      <Menu.Item key="discountCodes">
                        <Link to={`/discount-code`} activeclassname="active">
                          <DollarOutlined />
                          <span>Discount Code</span>
                        </Link>
                      </Menu.Item>
                    )}

                    {permissions?.includes(PERMISSIONS.VOUCHER_PAGE) && (
                      <SubMenu key="voucher-group" icon={<TagOutlined />} title="Voucher">
                        <Menu.Item key="vouchers">
                          <Link to={`/voucher`} activeclassname="active">
                            <TagOutlined />
                            <span>Voucher</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="voucher-history">
                          <Link to={`/voucher/history`} activeclassname="active">
                            <TagsOutlined />
                            <span>History</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>
                    )}

                    {permissions?.includes(PERMISSIONS.CAMPAIGN_PAGE) && (
                      <Menu.Item key="bonusCampaign">
                        <Link to={`/bonus-campaign`} activeclassname="active">
                          <GiftOutlined />
                          <span>Bonus Campaign</span>
                        </Link>
                      </Menu.Item>
                    )}

                    {permissions?.includes(
                      PERMISSIONS.VIEW_ACCOUNT_MANAGER_PAGE
                    ) && (
                      <Menu.Item key="accManager">
                        <Link to={`/account-manager`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Account Manager</span>
                        </Link>
                      </Menu.Item>
                    )}

                    {permissions?.includes(PERMISSIONS.VIEW_REFERRAL_PAGE) && (
                      <Menu.Item key="referralAccount">
                        <Link to={`/referral-account`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Referral Account</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.BANNER_PAGE) && (
                      <Menu.Item key="banner">
                        <Link to={`/banner`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Banner</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.NEWS_PAGE) && (
                      <Menu.Item key="news">
                        <Link to={`/news`} activeclassname="active">
                          <ContainerOutlined />
                          <span>News</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_ANNOUCEMENT) && (
                      <Menu.Item key="announcement">
                        <Link to={`/announcement`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Announcement</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_USER_PAGE) && getFeatureFlag("rewardPointsCheckout") && (
                      <Menu.Item key="pointHistory">
                        <Link to={`/point-history`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Point History</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.MISSION_PAGE) && getFeatureFlag("rewardPointsCheckout") && (
                      <Menu.Item key="mission">
                        <Link to={`/mission`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Mission</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.VIEW_CURRENCY_CONVERSION
                    ) && getFeatureFlag("rewardPointsCheckout") && (
                      <Menu.Item key="currency-conversion">
                        <Link
                          to={`/currency-conversion`}
                          activeclassname="active"
                        >
                          <ContainerOutlined />
                          <span>Currency Conversion</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_REWARD_CATALOG) && getFeatureFlag("rewardPointsCheckout") && (
                      <Menu.Item key="reward-catalog">
                        <Link to={`/reward-catalog`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Reward Catalog</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.VIEW_REDEMPTION_SETTINGS
                    ) && getFeatureFlag("rewardPointsCheckout") && (
                      <Menu.Item key="redemption-settings">
                        <Link
                          to={`/redemption-settings`}
                          activeclassname="active"
                        >
                          <ContainerOutlined />
                          <span>Redemption Settings</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_REDEMPTION_PAGE) && getFeatureFlag("rewardPointsCheckout") && (
                      <Menu.Item key="redemptions">
                        <Link to={`/redemptions`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Redemptions</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.VIEW_REDEMPTION_REPORT
                    ) && getFeatureFlag("rewardPointsCheckout") && (
                      <Menu.Item key="redemption-report">
                        <Link
                          to={`/redemption-report`}
                          activeclassname="active"
                        >
                          <ContainerOutlined />
                          <span>Redemption Report</span>
                        </Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}

                {permissions?.includes(PERMISSIONS.FINANCE_PAGE) && (
                  <SubMenu
                    key="finance"
                    icon={<TeamOutlined />}
                    title="Finance"
                  >
                    <SubMenu
                      key="remittance"
                      icon={<MoneyCollectOutlined />}
                      title="Remittance"
                    >
                      {permissions?.includes(
                        PERMISSIONS.UPDATE_REMITTANCE_STATUS
                      ) && (
                        <Menu.Item key="manual-remit">
                          <Link to={`/remittance`} activeclassname="active">
                            <CarryOutOutlined />
                            <span>Manual</span>
                          </Link>
                        </Menu.Item>
                      )}

                      {permissions?.includes(PERMISSIONS.VIEW_PAYOUT_PAGE) && (
                        <Menu.Item key="payout-list">
                          <Link to={`/payout`} activeclassname="active">
                            <MoneyCollectOutlined />
                            <span>Payout</span>
                          </Link>
                        </Menu.Item>
                      )}

                      {permissions?.includes(
                        PERMISSIONS.UPLOAD_CHECK_REMITTANCE
                      ) && (
                        <Menu.Item key="beneficiary">
                          <Link to={`/beneficiary`} activeclassname="active">
                            <ContainerOutlined />
                            <span>Beneficiary</span>
                          </Link>
                        </Menu.Item>
                      )}

                      {permissions?.includes(
                        PERMISSIONS.VIEW_BENEFICIARY_REQUEST_PAGE
                      ) && (
                        <Menu.Item key="beneficiary-request">
                          <Link to={`/beneficiary-request`} activeclassname="active">
                            <ContainerOutlined />
                            <span>Beneficiary Request</span>
                          </Link>
                        </Menu.Item>
                      )}

                      {permissions?.includes(
                        PERMISSIONS.UPLOAD_CHECK_REMITTANCE
                      ) && (
                        <Menu.Item key="check-remittance">
                          <Link
                            to={`/check-remittance`}
                            activeclassname="active"
                          >
                            <ContainerOutlined />
                            <span>Check</span>
                          </Link>
                        </Menu.Item>
                      )}
                    </SubMenu>
                    {permissions?.includes(
                      PERMISSIONS.VIEW_WEIGHT_DISPUTE_PAGE
                    ) && (
                      <SubMenu
                        key="weight-dispute-group"
                        icon={<RiseOutlined />}
                        title="Weight Dispute"
                      >
                        <Menu.Item key="weight-dispute">
                          <Link to={`/weight-dispute`} activeclassname="active">
                            <RiseOutlined />
                            <span>Weight Dispute</span>
                          </Link>
                        </Menu.Item>
                        <Menu.Item key="weight-dispute-by-merchant">
                          <Link
                            to={`/weight-dispute/merchant`}
                            activeclassname="active"
                          >
                            <UserOutlined />
                            <span>By Merchant</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>
                    )}
                    {permissions.includes(
                      PERMISSIONS.VIEW_COD_RECONCILATION_CALENDER
                    ) && (
                      <Menu.Item key="codCalender">
                        <Link to={`/cod-calender`} activeclassname="active">
                          <CalendarOutlined />
                          <span>COD Reconcilation Calender</span>
                        </Link>
                      </Menu.Item>
                    )}

                    {permissions?.includes(PERMISSIONS.PNL_PAGE) && (
                      <Menu.Item key="pnl">
                        <Link to={`/pnl`} activeclassname="active">
                          <ContainerOutlined />
                          <span>P&L Cost Calculation</span>
                        </Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}

                {permissions?.includes(PERMISSIONS.OPERATION_PAGE) && (
                  <SubMenu
                    key="operation"
                    icon={<TeamOutlined />}
                    title="Operation"
                  >
                    {permissions?.includes(
                      PERMISSIONS.BULK_DOWNLOAD_CONNOTE
                    ) && (
                      <SubMenu
                        key="consign-notes"
                        icon={<FilePdfOutlined />}
                        title="Consign Notes"
                      >
                        <Menu.Item key="bulk-download-consign-notes">
                          <Link
                            to={`/consign-notes/bulk-download`}
                            activeclassname="active"
                          >
                            <FilePdfOutlined />
                            <span>Bulk Download</span>
                          </Link>
                        </Menu.Item>
                      </SubMenu>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_INSURANCE_PAGE) && (
                      <Menu.Item key="insurance">
                        <Link to={`/insurance`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Insurance</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.VIEW_ISSUES) && (
                      <Menu.Item key="supportTickets">
                        <Link to={`/support-tickets`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Support Tickets</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.VIEW_CARGO_ACTIVATION
                    ) && (
                      <Menu.Item key="cargo-activation">
                        <Link
                          to={`/cargo-activations`}
                          activeclassname="active"
                        >
                          <ContainerOutlined />
                          <span>Cargo Activations</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(PERMISSIONS.FLYERS_REQUEST_PAGE) && (
                      <Menu.Item key="flyersRequest">
                        <Link to={`/flyers-request`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Flyers Request</span>
                        </Link>
                      </Menu.Item>
                    )}
                    {permissions?.includes(
                      PERMISSIONS.ADHOC_NOTIFICATION_PAGE
                    ) && (
                      <Menu.Item key="notifications">
                        <Link to={`/notifications`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Adhoc Notifications</span>
                        </Link>
                      </Menu.Item>
                    )}
                  </SubMenu>
                )}

                <SubMenu
                  key="setting"
                  icon={<SettingOutlined />}
                  title="System"
                >
                  {permissions?.includes(PERMISSIONS.SETTING_PAGE) && (
                    <Menu.Item key="system">
                      <Link to={`/system`} activeclassname="active">
                        <SettingOutlined />
                        <span>Settings</span>
                      </Link>
                    </Menu.Item>
                  )}
                  {permissions?.includes(PERMISSIONS.QUESTIONAIRE_PAGE) && (
                    <SubMenu key="questionaire-group" icon={<UserOutlined />} title="Questionaire">
                      <Menu.Item key="questionaire-result">
                        <Link to={`/questionaire/list`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Questionaire List</span>
                        </Link>
                      </Menu.Item>
                      <Menu.Item key="questionaire">
                        <Link to={`/questionaire/create`} activeclassname="active">
                          <ContainerOutlined />
                          <span>Add Questionaire</span>
                        </Link>
                      </Menu.Item>
                    </SubMenu>
                  )}
                  {permissions?.includes(PERMISSIONS.VIEW_OTP) && (
                    <Menu.Item key="otp-logs">
                      <Link to={`/otp-logs`} activeclassname="active">
                        <ContainerOutlined />
                        <span>Otp Logs</span>
                      </Link>
                    </Menu.Item>
                  )}
                  {permissions?.includes(PERMISSIONS.VIEW_EMAIL_LOGS) && (
                    <Menu.Item key="email">
                      <Link to={`/email`} activeclassname="active">
                        <MailOutlined />
                        <span>Email Logs</span>
                      </Link>
                    </Menu.Item>
                  )}
                  {permissions?.includes(PERMISSIONS.VIEW_ADMIN_AUDIT_LOGS) && (
                    <Menu.Item key="admin-audit-logs">
                      <Link to={`/admin-audit-logs`} activeclassname="active">
                        <ContainerOutlined />
                        <span>Admin Audit Logs</span>
                      </Link>
                    </Menu.Item>
                  )}
                  {permissions?.includes(PERMISSIONS.VIEW_USER_AUDIT) && (
                    <Menu.Item key="user-audit-logs">
                      <Link to={`/user-audit-logs`} activeclassname="active">
                        <ContainerOutlined />
                        <span>User Audit Logs</span>
                      </Link>
                    </Menu.Item>
                  )}
                  {permissions?.includes(PERMISSIONS.VIEW_EXPORT_PAGE) && (
                    <Menu.Item key="export">
                      <Link to={`/export`} activeclassname="active">
                        <ContainerOutlined />
                        <span>Export</span>
                      </Link>
                    </Menu.Item>
                  )}
                  <Menu.Item key="jobs">
                    <Link to={`/jobs`} activeclassname="active">
                      <CloudSyncOutlined />
                      <span>Jobs</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>

                <Menu.Item key="5">
                  <Link to={`/`} activeclassname="active" forcerefresh={"true"} onClick={() => handleLogout()}>
                    <LogoutOutlined />
                    <span>Logout{isAuthenticated}</span>
                  </Link>
                </Menu.Item>
              </Menu>
            </Sider>
            <Layout>
              <Header
                className="site-layout-sub-header-background"
                style={{
                  padding: 0,
                  backgroundColor: "#FFFFFF",
                  height: "64px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    padding: "0 20px",
                    height: "100%",
                  }}
                >
                  <p
                    style={{
                      color: "white",
                      backgroundColor: "#001529",
                      padding: "5px 15px",
                      borderRadius: "10px",
                      margin: 0,
                      height: "80%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {email}
                  </p>
                </div>
              </Header>

              <Content style={{ margin: "24px 16px 0" }}>
                <div style={{ padding: 24, minHeight: 360 }}>
                  {/* {this.props.children} */}
                  <Switch>
                    <Route exact path="/">
                      <Dashboard />
                    </Route>
                    <Route exact path="/user">
                      <User />
                    </Route>
                    <Route exact path="/discount-code">
                      <DiscountCode />
                    </Route>
                    <Route exact path="/voucher">
                      <Voucher />
                    </Route>
                    <Route exact path="/announcement">
                      <Announcement />
                    </Route>
                    <Route exact path="/point-history">
                      <PointHistory />
                    </Route>
                    <Route exact path="/mission">
                      <Mission />
                    </Route>
                    <Route exact path="/currency-conversion">
                      <CurrencyConversion />
                    </Route>
                    <Route exact path="/reward-catalog">
                      <RewardCatalog />
                    </Route>
                    <Route exact path="/redemption-settings">
                      <RedemptionSettings />
                    </Route>
                    <Route exact path="/redemptions">
                      <Redemption />
                    </Route>
                    <Route exact path="/redemption-report">
                      <RedemptionReport />
                    </Route>
                    <Route exact path="/bonus-campaign">
                      <BonusCampaign />
                    </Route>
                    <Route exact path="/voucher/history">
                      <VoucherRedemption />
                    </Route>
                    <Route exact path="/banner/active">
                      <BannerActive />
                    </Route>
                    <Route exact path="/banner/inactive">
                      <BannerInactive />
                    </Route>
                    <Route exact path="/all-order">
                      <AllOrder />
                    </Route>
                    <Route exact path="/order/next-day-remittance-order">
                      <NextDayRemittanceOrder />
                    </Route>
                    <Route exact path="/order/cod-order">
                      <CodOrder />
                    </Route>
                    <Route exact path="/order/cancel-request">
                      <CancelRequest />
                    </Route>
                    <Route exact path="/order/pod">
                      <POD />
                    </Route>
                    <Route exact path="/order/order-event">
                      <OrderEvent />
                    </Route>
                    <Route exact path="/weight-dispute">
                      <WeightDispute />
                    </Route>
                    <Route exact path="/weight-dispute/merchant">
                      <WeightDisputeByMerchant />
                    </Route>
                    <Route exact path="/order/unrecognized-status">
                      <UnrecognizedStatusOrder />
                    </Route>
                    <Route exact path="/order/pickup-request">
                      <PickupRequest />
                    </Route>
                    <Route exact path="/order/returned-order">
                      <ReturnedOrder />
                    </Route>
                    <Route exact path="/consign-notes/bulk-download">
                      <BulkDownloadConsignNote />
                    </Route>
                    <Route exact path="/analysis">
                      <Analysis />
                    </Route>
                    <Route exact path="/courier-order-analysis">
                      <CourierAnalysis />
                    </Route>
                    <Route exact path="/notification-analysis">
                      <NotificationAnalysis />
                    </Route>
                    <Route exact path="/cod-analysis">
                      <CodAnalysis />
                    </Route>
                    <Route exact path="/transaction">
                      <Transaction />
                    </Route>
                    <Route exact path="/news">
                      <News />
                    </Route>
                    <Route exact path="/insurance">
                      <Insurance />
                    </Route>
                    <Route exact path="/package">
                      <Package />
                    </Route>
                    <Route exact path="/topup-package/pricing">
                      <TopupPackagePricing />
                    </Route>
                    <Route exact path="/topup-package/cost">
                      <TopupPackageCost />
                    </Route>
                    <Route exact path="/fee-package/pricing">
                      <FeePackagePricing />
                    </Route>
                    <Route exact path="/courier-package/pricing">
                      <CourierPackagePricing />
                    </Route>
                    <Route exact path="/user/:id">
                      <UserDetails />
                    </Route>
                    <Route exact path="/remittance">
                      <Remittance />
                    </Route>
                    <Route exact path="/payout">
                      <Payout />
                    </Route>
                    <Route exact path="/beneficiary">
                      <Beneficiary />
                    </Route>
                    <Route exact path="/beneficiary-request">
                      <BeneficiaryRequest />
                    </Route>
                    <Route exact path="/check-remittance">
                      <CheckRemittance />
                    </Route>
                    <Route exact path="/account-manager">
                      <AccountManager />
                    </Route>
                    <Route exact path="/referral-account">
                      <ReferralAccount />
                    </Route>
                    <Route exact path="/account-manager/:id">
                      <AccountManagerDetails />
                    </Route>
                    <Route exact path="/referral-account/:id">
                      <ReferreeAccountList />
                    </Route>
                    <Route exact path="/questionaire/create">
                      <AddQuestionaire />
                    </Route>
                    <Route exact path="/questionaire/list">
                      <Questionaire />
                    </Route>
                    <Route exact path="/questionaire/result/:id">
                      <QuestionaireDetails />
                    </Route>
                    <Route exact path="/email">
                      <Email />
                    </Route>
                    <Route exact path="/export">
                      <Export />
                    </Route>
                    <Route exact path="/support-tickets">
                      <SupportTicket />
                    </Route>
                    <Route exact path="/cargo-activations">
                      <CargoActivation />
                    </Route>
                    <Route exact path="/support-tickets/:id">
                      <SupportTicketDetail />
                    </Route>
                    <Route exact path="/flyers-request">
                      <FlyersRequest />
                    </Route>
                    <Route exact path="/system">
                      <Settings />
                    </Route>
                    <Route exact path="/receiver/order-stats">
                      <ReceiverOrderStats />
                    </Route>
                    <Route exact path="/sub-account">
                      <SubAccount />
                    </Route>
                    <Route exact path="/sub-account/:id">
                      <SubAccountDetails />
                    </Route>
                    <Route exact path="/payout/status/:payoutId">
                      <PayoutStatus />
                    </Route>
                    <Route exact path="/cod-calender">
                      <CodCalendar />
                    </Route>
                    <Route exact path="/payout/withdrawal/:withdrawalId">
                      <PayoutWithdrawal />
                    </Route>
                    <Route exact path="/otp-logs">
                      <Otp />
                    </Route>
                    <Route exact path="/admin-audit-logs">
                      <AdminAuditLogs />
                    </Route>
                    <Route exact path="/user-audit-logs">
                      <UserAuditLogs />
                    </Route>
                    <Route exact path="/jobs">
                      <AdminJob />
                    </Route>
                    <Route exact path="/notifications">
                      <Notification />
                    </Route>
                    <Route exact path="/pnl">
                      <Pnl />
                    </Route>
                    <Route exact path="/order/claim-payout">
                      <ClaimPayout />
                    </Route>
                    <Route exact path="/banner">
                      <Banner />
                    </Route>
                  </Switch>
                </div>
              </Content>
              <Footer style={{ textAlign: "center" }}>
                ParcelDaily © {moment().format("YYYY")} All rights reserved.
              </Footer>
            </Layout>
          </Layout>
        </Router>
      ) : (
        <Login />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  token: state.auth.token,
  email: state.auth.email,
});

const mapDispatchToProps = (dispatch) => {
  return {
    LOGOUT: () => dispatch(LOGOUT()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
